var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('lw-container',[_c('lw-banner',{attrs:{"slot":"header"},slot:"header"}),_c('div',{staticClass:"fusion-class-body",attrs:{"slot":"main"},slot:"main"},[_c('el-lw-bread-crumb'),_c('schedule')],1),_c('lw-footer',{attrs:{"slot":"footer"},slot:"footer"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }